module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/thumbs/2-690e2f52944f51bd9a03ad6b137a093c.webp";